import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import hey from "@/lib/hey";

export default function (element: HTMLElement, dataset: any) {
  let tl = gsap.timeline({ paused: true });
  let get = gsap.utils.selector(element);

  tl.to(get(".hh_heading_text:not(.is-written)"), {
    yPercent: -110,
    stagger: 0.1,
  });
  tl.to(
    get(".hh_heading_writing"),
    {
      opacity: 1,
    },
    ">-0.5",
  );
  tl.from(
    get(".button_main_wrap"),
    {
      opacity: 0,
    },
    "<",
  );
  tl.from(
    get(".hh_bottom_wrap"),
    {
      opacity: 0,
    },
    "<",
  );

  // -- perspective image tunnel
  const imageWrap = element.querySelector(".hh_image_wrap") as HTMLElement;
  if (imageWrap) {
    imageWrap.style.perspective = "400px";
    imageWrap.style.overflow = "hidden";

    const positions = [
      // top row
      { x: 1, y: 1, size: 120 },
      { x: 14, y: 2, size: 110 },
      { x: 28, y: 1, size: 130 },
      { x: 42, y: 3, size: 105 },
      { x: 58, y: 2, size: 120 },
      { x: 72, y: 1, size: 110 },
      { x: 86, y: 3, size: 125 },
      { x: 96, y: 1, size: 115 },
      // upper left
      { x: 1, y: 14, size: 140 },
      { x: 12, y: 18, size: 115 },
      { x: 22, y: 12, size: 125 },
      // upper right
      { x: 78, y: 14, size: 130 },
      { x: 88, y: 10, size: 115 },
      { x: 96, y: 18, size: 135 },
      // mid-left
      { x: 0, y: 30, size: 130 },
      { x: 10, y: 35, size: 115 },
      { x: 2, y: 48, size: 140 },
      { x: 12, y: 55, size: 110 },
      { x: 0, y: 65, size: 125 },
      { x: 8, y: 72, size: 120 },
      // mid-right
      { x: 88, y: 28, size: 125 },
      { x: 96, y: 38, size: 115 },
      { x: 85, y: 48, size: 135 },
      { x: 94, y: 55, size: 110 },
      { x: 88, y: 65, size: 125 },
      { x: 96, y: 72, size: 120 },
      // lower left
      { x: 2, y: 82, size: 130 },
      { x: 14, y: 85, size: 115 },
      { x: 24, y: 80, size: 125 },
      // lower right
      { x: 76, y: 82, size: 120 },
      { x: 88, y: 78, size: 130 },
      { x: 95, y: 85, size: 115 },
      // bottom row
      { x: 2, y: 93, size: 120 },
      { x: 15, y: 95, size: 110 },
      { x: 28, y: 92, size: 125 },
      { x: 40, y: 95, size: 115 },
      { x: 52, y: 93, size: 110 },
      { x: 64, y: 95, size: 125 },
      { x: 76, y: 92, size: 115 },
      { x: 90, y: 95, size: 120 },
      // scattered mid-band (outside center content)
      { x: 20, y: 28, size: 110 },
      { x: 18, y: 45, size: 120 },
      { x: 22, y: 62, size: 115 },
      { x: 78, y: 30, size: 110 },
      { x: 82, y: 42, size: 120 },
      { x: 76, y: 58, size: 115 },
      // near-center flanks
      { x: 26, y: 38, size: 105 },
      { x: 74, y: 40, size: 105 },
      { x: 28, y: 55, size: 110 },
      { x: 72, y: 55, size: 110 },
    ];

    for (let i = 0; i < positions.length; i++) {
      const p = positions[i];
      const rotation = (Math.random() - 0.5) * 12;
      const img = document.createElement("img");
      img.src = `https://picsum.photos/seed/${i + 10}/240/240`;
      img.style.cssText = `
        position: absolute;
        width: ${p.size}px;
        height: ${p.size}px;
        object-fit: cover;
        left: ${p.x}%;
        top: ${p.y}%;
        transform: rotate(${rotation}deg);
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.12);
        opacity: 0;
        will-change: transform, opacity;
      `;
      imageWrap.appendChild(img);

      gsap.fromTo(
        img,
        { z: -500, opacity: 0 },
        {
          z: 500,
          opacity: 2,
          duration: 14 + Math.random() * 6,
          ease: "none",
          repeat: -1,
          delay: Math.random() * 14,
        },
      );
    }
  }

  onPageIn(async () => {
    hey.on("loaderComplete", () => {
      tl.play();
    });
  });
}
